import "@/App.css";
import { useMemo } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Programme from "@/components/Programme";
import Programs from "@/components/Programs";
import Location from "@/components/Location";
import Team from "@/components/Team";
import Tuition from "@/components/Tuition";
import Admissions from "@/components/Admissions";
import SignupForms from "@/components/SignupForms";
import Footer from "@/components/Footer";
import Analytics from "@/components/Analytics";
import AdminPage from "@/pages/AdminPage";
import SurveyPage from "@/pages/SurveyPage";
import CostGuidePage from "@/pages/CostGuidePage";

function LandingPage() {
  return (
    <>
      <Header />
      <Analytics />
      <main>
        <Hero />
        <About />
        <Programme />
        <Programs />
        <Location />
        <Team />
        <Tuition />
        <Admissions />
        <SignupForms />
      </main>
      <Footer />
    </>
  );
}

const toastConfig = {
  style: {
    background: "#111111",
    border: "1px solid #262626",
    color: "#FFFFFF",
  },
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/survey" element={<SurveyPage />} />
          <Route path="/cost-guide" element={<CostGuidePage />} />
        </Routes>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={toastConfig}
        />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
